import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import HelpButton from "../HelpContent/HelpButton";
import SmsIcon from "../../assets/icons/originator.svg2";
import RcsIcon from "../../assets/icons/sms_text.svg2";
import MessengerIcon from "../../assets/icons/messenger.svg2";
import WhatsappIcon from "../../assets/icons/whatsapp.svg2";
import EmailIcon from "../../assets/icons/icon_email-01.svg2";
import VoiceIcon from "../../assets/icons/icon_voice_tel-01.svg2";
import MyIcon from "../Common/MyIcon";
import {
  addNewMessage,
  BroadcastType,
  removeMessage,
  selectBroadcast,
  setBroadcast,
} from "../store/slices/broadcastSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  useGetCommsSettingsDataQuery,
  useGetHeaderSettingsDataQuery,
} from "../store/slices/settingsSlice";

export const availableChannels = {
  email: {
    label: "email",
    icon: EmailIcon,
    helpId: "broadcast-email",
    subText: "Send an email broadcast",
  },
  sms: {
    label: "sms",
    icon: SmsIcon,
    helpId: "broadcast-sms",
    subText: "Send a sms broadcast",
  },
  voice: {
    label: "voice",
    icon: VoiceIcon,
    helpId: "broadcast-voice",
    subText: "Send a voice broadcast",
  },
  // whatsapp: {
  //   label: "whatsapp",
  //   icon: WhatsappIcon,
  //   helpId: "whatsapp",
  //   subText: "Lorem ipsum, dolor sit amet",
  // },
  // messenger: {
  //   label: "messenger",
  //   icon: MessengerIcon,
  //   helpId: "messenger",
  //   subText: "Lorem ipsum, dolor sit amet",
  // },
  // rcs: {
  //   label: "rcs",
  //   icon: RcsIcon,
  //   helpId: "rcs",
  //   subText: "Lorem ipsum, dolor sit amet",
  // },
};

export default function BroadcastCommsSelector() {
  const values = useSelector(selectBroadcast);
  const dispatch = useDispatch();
  const { data: commsSettings } = useGetCommsSettingsDataQuery();
  const { data: headerSettings } = useGetHeaderSettingsDataQuery();

  return (
    <>
      <div className="row row-cols-3 g-3">
        {Object.values(availableChannels).map((c) => (
          <div className="col-6 col-sm-4" key={c.label}>
            <button
              type="button"
              className={`btn w-100 bg-white p-3 rounded-3 text-center position-relative border border-2 ${
                values.Messages.some((vc) => vc.Channel === c.label)
                  ? "border-blue"
                  : ""
              }`}
              onClick={() => {
                if (!commsSettings || !headerSettings) return;

                if (values.Messages.some((vc) => vc.Channel === c.label)) {
                  // remove
                  dispatch(removeMessage(c.label as "sms" | "voice" | "email"));
                } else {
                  // add
                  dispatch(
                    addNewMessage({
                      channel: c.label as "sms" | "voice" | "email",
                      commsSettings,
                      headerSettings,
                    })
                  );
                }
              }}
            >
              <div className="position-absolute top-0 start-0">
                <HelpButton helpKey={(c as any).helpId} />
              </div>
              {values.Messages.some((vc) => vc.Channel === c.label) ? (
                <FontAwesomeIcon
                  icon={faCheck}
                  className="position-absolute top-0 end-0 text-white bg-colored p-1"
                  style={{ borderBottomLeftRadius: 8 }}
                />
              ) : null}
              <div>
                <MyIcon Icon={c.icon} width={20} />
              </div>
              <div className="text-uppercase fw-bold small overflow-hidden mt-2">
                {c.label}
              </div>
              <div className="text-secondary small">{c.subText}</div>
            </button>
          </div>
        ))}
      </div>
      {values.Messages.length === 0 ? (
        <div className="alert alert-danger my-3">
          You need to select at least one channel.
        </div>
      ) : null}
    </>
  );
}
